{
	"abilities": "Permessi",
	"ability_admins_manage": "Gestisci amministratori",
	"ability_catalog_manage": "Gestisci catalogo",
	"ability_notifications_manage": "Gestisci notifiche",
	"ability_users_impersonate": "Impersona utenti",
	"ability_users_manage": "Gestisci utenti",
	"account": "Account",
	"account_copy": "Gestisci il profilo e le preferenze dell'interfaccia.",
	"account_preferences": "Preferenze account",
	"action_failed": "Non è stato possibile completare l'azione.",
	"action_failed_copy": "Nessuna modifica è stata applicata. Controlla la connessione e riprova.",
	"active_cards": "Carte attive",
	"active_expansions": "Espansioni attive",
	"activity": "Attività",
	"administrators": "Amministratori",
	"administrators_load_error": "Impossibile caricare gli amministratori.",
	"app_name": "Seal Ledger",
	"appearance": "Aspetto",
	"archive": "Archivia",
	"archive_card": "Archivia la carta?",
	"archive_card_copy": "La carta e le sue stampe spariranno dalle viste attive del catalogo. I record esistenti resteranno invariati.",
	"archive_expansion": "Archivia l'espansione?",
	"archive_expansion_copy": "L'espansione sparirà dalle viste attive del catalogo. I record esistenti resteranno invariati.",
	"archive_printing": "Archivia la stampa?",
	"archive_printing_copy": "La stampa sparirà dalle viste attive del catalogo. I record esistenti resteranno invariati.",
	"authenticator_devices": "Dispositivi autenticatore",
	"backoffice": "Backoffice",
	"ban_user": "Blocca utente",
	"ban_user_copy": "L'utente verrà disconnesso ovunque e non potrà più accedere finché il blocco non verrà rimosso.",
	"block_optional": "Blocco (facoltativo)",
	"cancel": "Annulla",
	"card": "Carta",
	"card_category": "Tipo di carta",
	"card_number_optional": "Numero carta (facoltativo)",
	"cards": "Carte",
	"catalog": "Catalogo",
	"catalog_record_not_found": "Non trovi la stampa?",
	"catalog_search_empty": "Nessuna stampa attiva corrisponde alla ricerca.",
	"catalog_search_error": "Impossibile cercare nel catalogo.",
	"catalog_search_for_match_copy": "Scegli manualmente una stampa esistente quando il suggerimento è incompleto o errato.",
	"catalog_reference": "Riferimento catalogo",
	"catalog_load_error": "Impossibile caricare i record del catalogo.",
	"catalog_quality_hint": "La qualità del catalogo è un'abitudine quotidiana.",
	"choose_image": "Scegli immagine",
	"close_navigation": "Chiudi navigazione",
	"collapse_navigation": "Riduci navigazione",
	"cost_optional": "Costo (facoltativo)",
	"create_card": "Crea carta",
	"create_catalog_record": "Crea un record di catalogo",
	"create_catalog_record_copy": "Crea la carta o la stampa mancante, poi torna qui per completare l'abbinamento.",
	"create_expansion": "Crea espansione",
	"create_printing": "Crea stampa",
	"dashboard": "Panoramica",
	"disabled": "Disattivato",
	"display_name": "Nome visualizzato",
	"edit": "Modifica",
	"edit_abilities": "Modifica permessi",
	"edit_expansion": "Modifica espansione",
	"email": "Email",
	"empty_activity": "Nessuna attività registrata.",
	"empty_administrators": "Nessun amministratore trovato.",
	"empty_cards": "Non ci sono ancora carte attive.",
	"empty_expansions": "Non ci sono ancora espansioni attive.",
	"empty_printings": "Non ci sono ancora stampe attive.",
	"empty_queue": "Nessun prodotto provider richiede una riconciliazione di catalogo.",
	"empty_users": "Nessun utente trovato.",
	"enabled": "Attivato",
	"expand_navigation": "Espandi navigazione",
	"expansion": "Espansione",
	"expansion_code": "Codice espansione",
	"expansion_kind": "Tipo di espansione",
	"expansions": "Espansioni",
	"image_asset_id_optional": "ID asset immagine (facoltativo)",
	"image_upload_failed": "Non è stato possibile caricare l'immagine. Riprova.",
	"image_uploaded": "Immagine caricata",
	"invite_admin": "Invita amministratore",
	"language": "Lingua",
	"loading": "Caricamento catalogo…",
	"loading_administrators": "Caricamento amministratori...",
	"loading_user_details": "Caricamento dettagli utente…",
	"loading_users": "Caricamento utenti...",
	"manage_catalog": "Gestisci catalogo",
	"match_error": "Impossibile confermare l'abbinamento.",
	"match_error_copy": "Il prodotto provider è ancora da risolvere. Riprova.",
	"match_this_printing": "Abbina questa stampa",
	"mfa_code": "Codice di verifica",
	"mfa_copy": "Scegli uno dei metodi di verifica disponibili per continuare al backoffice.",
	"mfa_email": "Codice email",
	"mfa_enabled": "MFA attiva",
	"mfa_error": "Non è stato possibile verificare il codice. Riprova o scegli un altro metodo.",
	"mfa_passkey": "Passkey",
	"mfa_recovery": "Codice di recupero",
	"mfa_send_email": "Invia codice email",
	"mfa_title": "Verifica la tua identità",
	"mfa_totp": "App di autenticazione",
	"mfa_unavailable": "Questo metodo di verifica non è ancora disponibile in questo client.",
	"mfa_use_passkey": "Usa passkey",
	"mfa_verify": "Verifica e continua",
	"mobile_push": "Notifiche push mobile",
	"name_optional": "Nome (facoltativo)",
	"needs_catalog": "Da catalogare",
	"new_card": "Nuova carta",
	"new_expansion": "Nuova espansione",
	"new_printing": "Nuova stampa",
	"no_suggested_match_copy": "Non è stato trovato alcun suggerimento automatico. Cerca prima nel catalogo esistente, senza creare un nuovo record.",
	"next": "Successiva",
	"no": "No",
	"notification_preferences": "Preferenze notifiche",
	"notification_preferences_hint": "Impostazioni di consegna risolte per questo utente.",
	"open_navigation": "Apri navigazione",
	"open_queue": "Apri coda",
	"overview": "Panoramica",
	"overview_copy": "Mantieni ordinato il catalogo e risolvi i prodotti del provider prima che creino attrito ai collezionisti.",
	"passkeys": "Passkey",
	"power_optional": "Potenza (facoltativa)",
	"previous": "Precedente",
	"printed_number_optional": "Numero stampato (facoltativo)",
	"printings": "Stampe",
	"profile": "Profilo",
	"profile_load_error": "Impossibile caricare il tuo profilo.",
	"provider_product": "Prodotto provider",
	"provider_version": "Versione provider",
	"queue_copy": "{{count}} prodotti provider richiedono una stampa canonica.",
	"queue_load_error": "Impossibile caricare la coda catalogo.",
	"recent_attention": "Richiede attenzione",
	"reconciliation": "Coda catalogo",
	"recovery_codes": "Codici di recupero",
	"review_match": "Rivedi abbinamento",
	"review_match_copy": "Controlla i suggerimenti oppure cerca nel catalogo esistente e scegli manualmente la stampa esatta.",
	"review_suggested_printings": "Esamina le stampe suggerite",
	"refresh": "Aggiorna",
	"retry": "Riprova",
	"retry_copy": "Controlla la connessione e riprova la richiesta.",
	"reset_filters": "Reimposta filtri",
	"save_changes": "Salva modifiche",
	"search": "Cerca nel catalogo",
	"search_queue": "Cerca prodotti provider",
	"search_existing_printings": "Cerca stampe esistenti",
	"search_users": "Cerca utenti",
	"send_invite": "Invia invito",
	"series_optional": "Serie (facoltativa)",
	"session": "Sessione",
	"session_copy": "Esci da questo browser quando hai finito.",
	"sign_out": "Esci",
	"suggestion": "Abbinamento suggerito",
	"theme_dark": "Scuro",
	"theme_light": "Chiaro",
	"theme_system": "Sistema",
	"unban_user": "Rimuovi blocco",
	"unban_user_copy": "Questo ripristina la possibilità dell'utente di accedere.",
	"unknown_ip": "IP sconosciuto",
	"upload_card_image": "Carica immagine carta",
	"upload_card_image_hint": "JPEG, PNG o WebP fino a 10 MB.",
	"uploading_image": "Caricamento…",
	"user_activity_hint": "Eventi recenti dell'account e di accesso.",
	"user_detail_error": "Non è stato possibile caricare i dettagli utente.",
	"user_security": "Sicurezza utente",
	"users": "Utenti",
	"users_load_error": "Impossibile caricare gli utenti.",
	"variant": "Variante",
	"welcome": "Buongiorno, curatore.",
	"yes": "Sì",
	"actions": "Azioni",
	"active": "Attivo",
	"all_card_categories": "Tutti i tipi di carta",
	"all_expansion_kinds": "Tutti i tipi di espansione",
	"all_languages": "Tutte le lingue",
	"all_mfa_states": "Tutti gli stati MFA",
	"all_statuses": "Tutti gli stati",
	"all_variants": "Tutte le varianti",
	"all_verification_states": "Tutti gli stati di verifica",
	"announced": "Annunciata",
	"administrator": "Amministratore",
	"banned": "Bloccato",
	"block": "Blocco",
	"card_number": "Numero carta",
	"cost": "Costo",
	"deleted": "Eliminato",
	"email_verification": "Verifica email",
	"filter_by_card_category": "Filtra per tipo di carta",
	"filter_by_email_verification": "Filtra per verifica email",
	"filter_by_expansion_kind": "Filtra per tipo di espansione",
	"filter_by_language": "Filtra per lingua",
	"filter_by_mfa": "Filtra per MFA",
	"filter_by_status": "Filtra per stato",
	"filter_by_variant": "Filtra per variante",
	"image": "Immagine",
	"mfa": "MFA",
	"mfa_disabled": "MFA disattivata",
	"overview_queue_copy": "Apri la coda per verificare i prodotti provider che necessitano ancora di una stampa canonica in catalogo.",
	"overview_load_error": "Impossibile caricare le statistiche della panoramica.",
	"power": "Potenza",
	"pending": "In attesa",
	"printed_number": "Numero stampato",
	"release_date": "Data di uscita",
	"released": "Pubblicata",
	"series": "Serie",
	"select_card": "Seleziona una carta",
	"select_expansion": "Seleziona un'espansione",
	"status": "Stato",
	"suggested_matches": "Abbinamenti suggeriti",
	"unnamed_administrator": "Amministratore senza nome",
	"unnamed_user": "Utente senza nome",
	"user": "Utente",
	"verified": "Verificata",
	"unverified": "Non verificata",
	"go_overview": "Vai alla panoramica",
	"not_found": "Pagina non trovata",
	"not_found_copy": "Questa pagina del backoffice non esiste o non è più disponibile.",
	"unexpected_error": "Qualcosa è andato storto.",
	"unexpected_error_copy": "Non è stato possibile visualizzare la pagina. Riprova o torna alla panoramica."
}
